exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ItemZoomControl[data-v-c8ec5726] {\n  display: grid;\n  grid-template-columns: 50px 1fr;\n}\n.ItemZoomControl_Label[data-v-c8ec5726] {\n    text-align: right;\n}\n.ItemZoomControl_Item[data-v-c8ec5726] {\n    padding: 0 10px;\n}\n.ItemZoomControl_Range[data-v-c8ec5726] {\n    height: 20px;\n}\n", ""]);

// exports
